import React, { useState } from 'react';
import styles from '../pages/UserDetailsPage.module.css';
import { updateUserFunds } from '../utils/api';

const Funds = ({ userId, user, setUser, onSaveSuccess }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editType, setEditType] = useState(null); // 'fund' or 'withdrawalFund'
    const [amount, setAmount] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleEditClick = (type) => {
        setIsEditing(true);
        setEditType(type);
        setAmount(type === 'fund' ? user.fund.toString() : user.withdrawalFund.toString());
    };

    const handleCancel = () => {
        setIsEditing(false);
        setEditType(null);
        setAmount('');
    };

    const handleProcessFund = async () => {
        if (amount === '' || isNaN(amount) || parseFloat(amount) < 0) {
            alert('Please enter a valid amount');
            return;
        }

        try {
            setIsSubmitting(true);

            // Update the specific fund field
            const payload = { [editType]: parseFloat(amount) };
            const res = await updateUserFunds(userId, payload);
            setUser(res.data);
            alert(`${editType === 'fund' ? 'Trading' : 'Withdrawal'} fund updated successfully`);

            if (onSaveSuccess) {
                onSaveSuccess();
            }
            handleCancel();
        } catch (err) {
            console.error('[Admin Frontend] Fund operation failed', err);
            alert('Operation failed');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={styles['funds-container']}>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Trading Fund (INR):</span>
                <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>₹{user.fund.toLocaleString()}</span>
                <button className={styles['btn-approve']} onClick={() => handleEditClick('fund')} style={{ marginLeft: '10px', padding: '2px 8px', fontSize: '0.8rem', backgroundColor: '#52c41a' }}>Edit</button>
            </div>
            <div className={styles['info-group']}>
                <span className={styles['info-label']}>Withdrawal Fund (INR):</span>
                <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>₹{user.withdrawalFund.toLocaleString()}</span>
                <button className={styles['btn-approve']} onClick={() => handleEditClick('withdrawalFund')} style={{ marginLeft: '10px', padding: '2px 8px', fontSize: '0.8rem', backgroundColor: '#1890ff' }}>Edit</button>
            </div>

            {isEditing && (
                <div className={styles['edit-fund-form']} style={{ marginTop: '1rem', border: '1px solid #ddd', padding: '1rem', borderRadius: '8px' }}>
                    <h3>Edit {editType === 'fund' ? 'Trading' : 'Withdrawal'} Fund</h3>
                    
                    <div className={styles['form-group']}>
                        <label>New {editType === 'fund' ? 'Trading' : 'Withdrawal'} Fund Amount:</label>
                        <input 
                            type="number" 
                            value={amount} 
                            onChange={(e) => setAmount(e.target.value)} 
                            placeholder="Enter amount"
                        />
                    </div>

                    <div className={styles['fund-actions']}>
                        <button className={styles['btn-approve']} onClick={handleProcessFund} disabled={isSubmitting}>
                            {isSubmitting ? 'Processing...' : 'Confirm'}
                        </button>
                        <button className={styles['delete-button']} onClick={handleCancel} disabled={isSubmitting}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Funds;
